<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 512 512"
		class="absolute top-0 left-0 h-0 w-0 opacity-0"
	>
		<defs>
			<linearGradient id="g" x1="-300%" x2="-200%" y1="0" y2="0">
				<stop offset="-10%" stop-opacity=".1" stop-color="#fff" />
				<stop offset="30%" stop-opacity=".07" stop-color="#fff" />
				<stop offset="70%" stop-opacity=".07" stop-color="#fff" />
				<stop offset="110%" stop-opacity=".1" stop-color="#fff" />
				<animate
					attributeName="x1"
					from="-300%"
					to="1200%"
					dur="3s"
					repeatCount="indefinite"
				/>
				<animate
					attributeName="x2"
					from="-200%"
					to="1300%"
					dur="3s"
					repeatCount="indefinite"
				/>
			</linearGradient>
		</defs>
	</svg>
</template>
